// extracted by mini-css-extract-plugin
export default {"container":"Select_container__76g9E","label":"Select_label__fi2tj","required":"Select_required__Nqj5G","select":"Select_select__K68bk"};